export const CATEGORY_MEDIA_BUCKET = 'category-media' as const;
export const MAX_CATEGORY_IMAGE_BYTES = 2 * 1024 * 1024;

export const ACCEPTED_CATEGORY_IMAGE_MIME = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
} as const;

export type AcceptedCategoryImageMime = keyof typeof ACCEPTED_CATEGORY_IMAGE_MIME;
export type CategoryImageExtension =
  (typeof ACCEPTED_CATEGORY_IMAGE_MIME)[AcceptedCategoryImageMime];
export type CategoryImageValidationError = 'imageTooLarge' | 'imageInvalidType';

export function validateCategoryImageFile(file: File): CategoryImageValidationError | null {
  if (file.size > MAX_CATEGORY_IMAGE_BYTES) {
    return 'imageTooLarge';
  }

  if (!Object.prototype.hasOwnProperty.call(ACCEPTED_CATEGORY_IMAGE_MIME, file.type)) {
    return 'imageInvalidType';
  }

  return null;
}

export function getCategoryFileExtension(mime: string): CategoryImageExtension {
  if (Object.prototype.hasOwnProperty.call(ACCEPTED_CATEGORY_IMAGE_MIME, mime)) {
    return ACCEPTED_CATEGORY_IMAGE_MIME[mime as AcceptedCategoryImageMime];
  }
  return 'jpg';
}
